// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_case_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ApprovalMode, ApprovalStrategy } from "../../bfftypes/v1/approval_flow_type_pb";
import { file_bfftypes_v1_approval_flow_type } from "../../bfftypes/v1/approval_flow_type_pb";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { LinkedPageKind, WorkflowCaseTag, WorkflowSection } from "./workflow_template_model_pb";
import { file_bffuser_v1_workflow_template_model } from "./workflow_template_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_case_model.proto.
 */
export const file_bffuser_v1_workflow_case_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_approval_flow_type, file_bfftypes_v1_area, file_bffuser_v1_workflow_template_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * WorkflowCase is the root aggregate for a workflow execution instance as
 * exposed to the BFF / frontend layer.
 * Mirrors internalapi.v1.WorkflowCase.
 *
 * @generated from message bffuser.v1.WorkflowCase
 */
export type WorkflowCase = Message<"bffuser.v1.WorkflowCase"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workflow_template_id = 2;
   */
  workflowTemplateId: string;

  /**
   * workflow_template_name is a snapshot of the template name taken at case
   * creation time.
   *
   * @generated from field: string workflow_template_name = 3;
   */
  workflowTemplateName: string;

  /**
   * @generated from field: google.type.Date target_date = 5;
   */
  targetDate?: Date;

  /**
   * @generated from field: bffuser.v1.WorkflowSection section = 7;
   */
  section: WorkflowSection;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 19;
   */
  areaCode: AreaCode;

  /**
   * status is a backend-computed derived field. Always populated in responses;
   * must NOT be set in Create / Update request messages.
   *
   * @generated from field: bffuser.v1.WorkflowCaseStatus status = 10;
   */
  status: WorkflowCaseStatus;

  /**
   * completed_at and completed_by are stamped automatically once every
   * sub-step is resolved (spec AC-WFW-008; completed_by is the resolving
   * actor of the final sub-step). Mutually exclusive with deleted_at
   * (completion_note (field 13) was removed in spec B2).
   *
   * @generated from field: optional google.protobuf.Timestamp completed_at = 11;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: optional string completed_by = 12;
   */
  completedBy?: string;

  /**
   * @generated from field: repeated bffuser.v1.BigStepInstance big_steps = 14;
   */
  bigSteps: BigStepInstance[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 16;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string created_by = 17;
   */
  createdBy?: string;

  /**
   * @generated from field: optional string updated_by = 18;
   */
  updatedBy?: string;

  /**
   * workflow_id is the human-readable business key (e.g. R-D1-20260423-2E3B).
   *
   * @generated from field: string workflow_id = 20;
   */
  workflowId: string;

  /**
   * bg_code is the code selected at creation time (a BG code, or a 発電の
   * 計画提出者コード for a template with allows_generation_target_code). Unset when the source
   * template requires no BG code (workflow-bg-code-derivation design); the
   * frontend renders 「—」 in that case. Mirrors
   * internalapi.v1.WorkflowCase.bg_code.
   *
   * @generated from field: optional string bg_code = 21;
   */
  bgCode?: string;

  /**
   * bg_name is a snapshot of the BG name (for a 発電の計画提出者コード, the
   * 計画提出者マスタ's submitter_name) at creation time. Unset exactly when
   * bg_code is unset.
   *
   * @generated from field: optional string bg_name = 22;
   */
  bgName?: string;

  /**
   * rep_business_name is a snapshot of the representative business name
   * (発注主体名; for a 発電の計画提出者コード, the 計画提出者マスタ's business_name)
   * at creation time. Unset exactly when bg_code is unset.
   *
   * @generated from field: optional string rep_business_name = 23;
   */
  repBusinessName?: string;

  /**
   * tags are user-defined label + color pairs attached to this case
   * (spec AC-TAG-001..004). Mirrors internalapi.v1.WorkflowCase.tags (field
   * 25 — 24 was already in use by assignee_member_id at implementation
   * time).
   *
   * @generated from field: repeated bffuser.v1.WorkflowCaseTag tags = 25;
   */
  tags: WorkflowCaseTag[];

  /**
   * deleted_at / deleted_by mirror internalapi.v1.WorkflowCase
   * (workflow-delete-transition design). deleted_by is injected by the BFF
   * handler from the eauth session (frontend does not send it in the
   * request; only receives it back in responses).
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 26;
   */
  deletedAt?: Timestamp;

  /**
   * @generated from field: optional string deleted_by = 27;
   */
  deletedBy?: string;

  /**
   * responder_member_ids mirrors
   * internalapi.v1.WorkflowCase.responder_member_ids (= 対応者), de-duplicated
   * and ordered by (big_step.display_order, sub_step.display_order). See
   * that field's godoc for the IN_PROGRESS / AWAITING_APPROVAL derivation
   * (workflow-case-list-12col-viewer-action-4value slice, spec §244).
   * Populated ONLY by the ListWorkflowCases response; empty elsewhere means
   * "not supplied".
   *
   * @generated from field: repeated string responder_member_ids = 32;
   */
  responderMemberIds: string[];

  /**
   * viewer_action mirrors internalapi.v1.WorkflowCase.viewer_action
   * (= あなたの対応). Populated ONLY by the ListWorkflowCases response;
   * UNSPECIFIED elsewhere means "not supplied", not NONE.
   *
   * @generated from field: bffuser.v1.WorkflowCaseViewerAction viewer_action = 33;
   */
  viewerAction: WorkflowCaseViewerAction;

  /**
   * demand_step_confirmed is a backend-computed derived field that reports
   * whether the first big step (需要想定) has at least one business-confirmed
   * record (demand_confirm_record with category = BUSINESS_CONFIRMED) for this
   * case. Populated by GetWorkflowCase; NOT populated by ListWorkflowCases
   * (本 slice では demand-forecast-daily 起点の Get のみ配線)。The frontend
   * OR's this with the existing COMPLETE/DELETED status to derive the
   * demand-forecast read-only state (AC-DFC-007)。この field を Create /
   * Update request で set することは禁止 (status と同扱い)。
   *
   * @generated from field: optional bool demand_step_confirmed = 36;
   */
  demandStepConfirmed?: boolean;

  /**
   * Field 37 (viewer_action_required_count) was removed entirely — no longer
   * reserved, mirroring internalapi.v1.WorkflowCase's field 37 removal
   * (workflow-case-list-12col-viewer-action-4value slice, spec §242). Same
   * wire-compat-deviation rationale as that field's godoc.
   *
   * Fields 38 (viewer_action_required_linked_page_kind) and 39
   * (viewer_action_required_linked_plan_id — bffuser-only, never mirrored in
   * internalapi.v1.WorkflowCase, which closes at field 38) were removed
   * entirely — no longer reserved, mirroring internalapi.v1.WorkflowCase's
   * field 38 removal (workflow-case-list-12col-viewer-action-4value slice,
   * 2026-08-19 spec AC-WFW-001 §243 追従改訂 D5/D6: the 要承認/要対応 buttons
   * now both navigate to the case detail page with an active-sub-step focus
   * signal instead of a business linked page, so the BFF-side plan-id
   * resolution these two fields carried — resolve_linked_plan.go's
   * resolveViewerActionRequiredLinkedPlanID(s) — is entirely dead). Same
   * wire-compat-deviation rationale as that field's godoc.
   *
   * demand_forecast_status is a backend-computed derived field (issue #6624:
   * 需要想定の一覧/詳細ステータス食い違い修正) reporting the 需要想定サブ
   * ステップ軸のステータス — the SAME axis the 需要想定一覧
   * (DemandForecastListPage) screen shows. This is DELIBERATELY a different
   * axis from `status` (field 10, ケース全体軸): a case can be 需要想定確定済み
   * (this field COMPLETE) while the overall workflow is still IN_PROGRESS,
   * and vice versa. Populated ONLY by GetWorkflowCase — same gate as
   * demand_step_confirmed (field 36) above; every other RPC (including
   * ListWorkflowCases) leaves this field unset (= judgment unavailable, not
   * NOT_STARTED). Setting this field in Create / Update request messages is
   * forbidden (same treatment as `status`). Field numbers 37, 38, and 39
   * were all removed above (see their godoc); this field is appended after
   * all three at field number 40 so it does not reuse a number that was
   * live moments ago. Mirrors internalapi.v1.WorkflowCase.demand_forecast_status.
   *
   * @generated from field: optional bffuser.v1.WorkflowCaseStatus demand_forecast_status = 40;
   */
  demandForecastStatus?: WorkflowCaseStatus;

  /**
   * demand_confirmed_at / demand_confirmed_by record the confirm timestamp /
   * actor of THIS case's 需要想定 axis confirm record (issue #8453:
   * demand-forecast-daily メタ情報バーの確定日時・確定者、AC-DFD-050/051).
   * This is a DIFFERENT axis from completed_at / completed_by (fields
   * 11/12, WF ケース全体軸 — stamped once every sub-step resolves, spec
   * AC-WFW-008): a case can have demand_confirmed_at set while completed_at
   * is still unset (需要想定だけ確定し他のサブステップは未完了), and vice
   * versa (WF 全体が完了しても需要想定の確定記録が無い/revoke 済みなら両方
   * unset). Populated ONLY by GetWorkflowCase — same gate as
   * demand_step_confirmed / demand_forecast_status (fields 36/40); every
   * other RPC (including ListWorkflowCases) leaves both fields unset.
   * Setting these fields in Create / Update request messages is forbidden
   * (same treatment as `status`). Mirrors
   * internalapi.v1.WorkflowCase.demand_confirmed_at /
   * internalapi.v1.WorkflowCase.demand_confirmed_by.
   *
   * @generated from field: optional google.protobuf.Timestamp demand_confirmed_at = 41;
   */
  demandConfirmedAt?: Timestamp;

  /**
   * @generated from field: optional string demand_confirmed_by = 42;
   */
  demandConfirmedBy?: string;

  /**
   * suspended_at / suspended_by / suspend_reason mirror
   * internalapi.v1.WorkflowCase (suspended_by is the member_id; the display name
   * is resolved the same way as deleted_by).
   *
   * @generated from field: optional google.protobuf.Timestamp suspended_at = 43;
   */
  suspendedAt?: Timestamp;

  /**
   * @generated from field: optional string suspended_by = 44;
   */
  suspendedBy?: string;

  /**
   * @generated from field: optional string suspend_reason = 45;
   */
  suspendReason?: string;
};

/**
 * Describes the message bffuser.v1.WorkflowCase.
 * Use `create(WorkflowCaseSchema)` to create a new message.
 */
export const WorkflowCaseSchema: GenMessage<WorkflowCase> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_model, 0);

/**
 * WorkflowCaseConflict describes a single (area_code, target_date) pair that
 * conflicts with an existing open workflow case. Mirrors
 * internalapi.v1.WorkflowCaseConflict.
 *
 * @generated from message bffuser.v1.WorkflowCaseConflict
 */
export type WorkflowCaseConflict = Message<"bffuser.v1.WorkflowCaseConflict"> & {
  /**
   * area_code is the area of the conflicting BG. UNSPECIFIED for a "BG なし"
   * conflict (issue #5219).
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * existing_workflow_id is the human-readable workflow_id of the already-open
   * case that causes the conflict.
   *
   * @generated from field: string existing_workflow_id = 3;
   */
  existingWorkflowId: string;

  /**
   * bg_code is the code (BG code or 発電の計画提出者コード) involved in the conflict. Included so the frontend
   * can identify which BG triggered the exclusive-constraint violation. Unset
   * for a "BG なし" conflict; the frontend renders that axis as 「BG なし」.
   *
   * @generated from field: optional string bg_code = 4;
   */
  bgCode?: string;

  /**
   * bg_name is the existing case's name snapshot (BG 名 or 計画提出者名), empty for a
   * "BG なし" conflict (issue #5219, mirrors internalapi.v1.WorkflowCaseConflict).
   *
   * @generated from field: string bg_name = 5;
   */
  bgName: string;
};

/**
 * Describes the message bffuser.v1.WorkflowCaseConflict.
 * Use `create(WorkflowCaseConflictSchema)` to create a new message.
 */
export const WorkflowCaseConflictSchema: GenMessage<WorkflowCaseConflict> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_model, 1);

/**
 * BigStepInstance is a top-level step group within a WorkflowCase.
 * See internalapi.v1.BigStepInstance for field semantics.
 *
 * @generated from message bffuser.v1.BigStepInstance
 */
export type BigStepInstance = Message<"bffuser.v1.BigStepInstance"> & {
  /**
   * @generated from field: int32 display_order = 1;
   */
  displayOrder: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: repeated bffuser.v1.SubStepInstance sub_steps = 6;
   */
  subSteps: SubStepInstance[];
};

/**
 * Describes the message bffuser.v1.BigStepInstance.
 * Use `create(BigStepInstanceSchema)` to create a new message.
 */
export const BigStepInstanceSchema: GenMessage<BigStepInstance> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_model, 2);

/**
 * SubStepInstance is a leaf-level task within a BigStepInstance.
 * See internalapi.v1.SubStepInstance for field semantics.
 *
 * @generated from message bffuser.v1.SubStepInstance
 */
export type SubStepInstance = Message<"bffuser.v1.SubStepInstance"> & {
  /**
   * @generated from field: int32 display_order = 1;
   */
  displayOrder: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * linked_page_kind identifies the application page this sub-step links to.
   * UNSPECIFIED means no link is displayed. The frontend derives the URL and
   * label from this enum value via routePaths.
   *
   * @generated from field: optional bffuser.v1.LinkedPageKind linked_page_kind = 4;
   */
  linkedPageKind?: LinkedPageKind;

  /**
   * @generated from field: bool is_completed = 6;
   */
  isCompleted: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 7;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: optional string completed_by = 8;
   */
  completedBy?: string;

  /**
   * status is a backend-computed derived field reflecting the sub-step's
   * progress state. Mirrors internalapi.v1.SubStepInstance.status.
   *
   * @generated from field: bffuser.v1.SubStepStatus status = 9;
   */
  status: SubStepStatus;

  /**
   * auto_skipped_at is set when the sub-step was automatically skipped.
   *
   * @generated from field: optional google.protobuf.Timestamp auto_skipped_at = 10;
   */
  autoSkippedAt?: Timestamp;

  /**
   * skip_reason is a human-readable reason for the automatic skip.
   *
   * @generated from field: optional string skip_reason = 11;
   */
  skipReason?: string;

  /**
   * approval_stages is the backend-resolved approval view for this sub-step.
   *
   * @generated from field: repeated bffuser.v1.SubStepApprovalStage approval_stages = 12;
   */
  approvalStages: SubStepApprovalStage[];

  /**
   * assignee_member_ids lists the eauth member_ids of the members in charge
   * of this sub-step (0..N, spec AC-WFW-001/AC-WFW-005c). Empty = 担当者なし.
   * Mirrors internalapi.v1.SubStepInstance.assignee_member_ids.
   *
   * Field 13 was rewritten in-place from `optional string assignee_member_id`
   * to `repeated string assignee_member_ids` (issue #4550). This is a wire
   * breaking change; pre-release + monorepo atomic deploy is what makes it
   * safe (no external v1 client). See the sibling SubStepTemplate.assignee_member_ids
   * comment in workflow_template_model.proto for the full rationale.
   *
   * @generated from field: repeated string assignee_member_ids = 13;
   */
  assigneeMemberIds: string[];

  /**
   * memo is the free-text hand-over note for this sub-step (spec AC-005b).
   * Mirrors internalapi.v1.SubStepInstance.memo.
   *
   * @generated from field: optional string memo = 14;
   */
  memo?: string;

  /**
   * memo_by is the eauth member_id of the last person who wrote the memo.
   * Mirrors internalapi.v1.SubStepInstance.memo_by.
   *
   * @generated from field: optional string memo_by = 15;
   */
  memoBy?: string;

  /**
   * memo_at is the timestamp of the last memo write. Mirrors
   * internalapi.v1.SubStepInstance.memo_at.
   *
   * @generated from field: optional google.protobuf.Timestamp memo_at = 16;
   */
  memoAt?: Timestamp;

  /**
   * cancel_memo is the free-text reason recorded when an approver cancels
   * the sub-step's pending approvals (spec AC-WFW-007d). Mirrors
   * internalapi.v1.SubStepInstance.cancel_memo.
   *
   * @generated from field: optional string cancel_memo = 17;
   */
  cancelMemo?: string;

  /**
   * cancelled_by is the eauth member_id of the approver who cancelled the
   * pending approvals. Mirrors internalapi.v1.SubStepInstance.cancelled_by.
   *
   * @generated from field: optional string cancelled_by = 18;
   */
  cancelledBy?: string;

  /**
   * cancelled_at is the timestamp at which the pending approvals were
   * cancelled. Mirrors internalapi.v1.SubStepInstance.cancelled_at.
   *
   * @generated from field: optional google.protobuf.Timestamp cancelled_at = 19;
   */
  cancelledAt?: Timestamp;

  /**
   * linked_plan_id is the resolved plan_submission.id when this sub-step's
   * linked_page_kind is PLAN_PROCUREMENT or PLAN_GEN_SALES and the current
   * workflow has a plan_submission record created from it (matched on the
   * plan_submission.workflow_id column). Empty when unresolved or when
   * linked_page_kind is not a plan kind. The frontend uses this to build the
   * detail-route URL; empty falls back to the list route with ?workflowId=
   * (current resolveLinkedPage behavior).
   *
   * NOTE: resolved by the BFF from plan_submission (BFF-side derived
   * field). Not mirrored in internalapi.v1.SubStepInstance — this is an
   * explicit exception to the bffuser <-> internalapi field-mirror
   * invariant declared in this message's godoc ("See
   * internalapi.v1.SubStepInstance for field semantics.").
   *
   * @generated from field: optional string linked_plan_id = 20;
   */
  linkedPlanId?: string;

  /**
   * uncompleted_by is the eauth member_id of the actor who undid the
   * sub-step completion (Action=完了取消). Mirrors
   * internalapi.v1.SubStepInstance.uncompleted_by.
   *
   * @generated from field: optional string uncompleted_by = 21;
   */
  uncompletedBy?: string;

  /**
   * uncompleted_at is the timestamp at which the sub-step completion was
   * undone. Mirrors internalapi.v1.SubStepInstance.uncompleted_at.
   *
   * @generated from field: optional google.protobuf.Timestamp uncompleted_at = 22;
   */
  uncompletedAt?: Timestamp;

  /**
   * cancel_is_approver_not_applicable is true when the actor of the last
   * cancel (差戻し) was not a designated approver of the current stage at that
   * time, i.e. the first unsatisfied stage (spec AC-WFW-007c). Mirrors
   * internalapi.v1.SubStepInstance.cancel_is_approver_not_applicable.
   *
   * @generated from field: bool cancel_is_approver_not_applicable = 23;
   */
  cancelIsApproverNotApplicable: boolean;

  /**
   * cancel_is_self_approval is true when the actor of the last cancel
   * (差戻し) was the sub-step's applicant (spec AC-WFW-007c). Mirrors
   * internalapi.v1.SubStepInstance.cancel_is_self_approval.
   *
   * @generated from field: bool cancel_is_self_approval = 24;
   */
  cancelIsSelfApproval: boolean;

  /**
   * viewer_is_self_approval mirrors
   * internalapi.v1.SubStepInstance.viewer_is_self_approval: an approval or a
   * cancel (差戻し) by the viewer (the signed-in member) would be recorded as
   * 「自己承認」.
   *
   * @generated from field: bool viewer_is_self_approval = 25;
   */
  viewerIsSelfApproval: boolean;

  /**
   * viewer_cancel_is_approver_not_applicable mirrors
   * internalapi.v1.SubStepInstance.viewer_cancel_is_approver_not_applicable.
   *
   * @generated from field: bool viewer_cancel_is_approver_not_applicable = 26;
   */
  viewerCancelIsApproverNotApplicable: boolean;

  /**
   * undone_completions is the 完了取消 history of this sub-step (spec
   * AC-WFW-005f, #10423): one entry per undo, oldest first. Supersedes the
   * single-slot uncompleted_by / uncompleted_at, which keep carrying the
   * latest undo for consumers that have not moved yet.
   *
   * @generated from field: repeated bffuser.v1.SubStepUndoneCompletion undone_completions = 27;
   */
  undoneCompletions: SubStepUndoneCompletion[];

  /**
   * completion_trigger mirrors
   * internalapi.v1.SubStepInstance.completion_trigger.
   *
   * @generated from field: bffuser.v1.SubStepCompletionTrigger completion_trigger = 28;
   */
  completionTrigger: SubStepCompletionTrigger;

  /**
   * Mirrors internalapi.v1.SubStepInstance.approval_without_stages.
   *
   * @generated from field: bffuser.v1.SubStepStageApproval approval_without_stages = 29;
   */
  approvalWithoutStages?: SubStepStageApproval;

  /**
   * Mirrors internalapi.v1.SubStepInstance.requires_approval_without_stages.
   *
   * @generated from field: bool requires_approval_without_stages = 30;
   */
  requiresApprovalWithoutStages: boolean;

  /**
   * @generated from field: repeated bffuser.v1.SubStepStageApprovalNote previous_approval_without_stages_notes = 31;
   */
  previousApprovalWithoutStagesNotes: SubStepStageApprovalNote[];

  /**
   * completed_is_assignee_not_applicable mirrors
   * internalapi.v1.SubStepInstance.completed_is_assignee_not_applicable:
   * 「担当者非該当」 on the standing completion (spec AC-WFW-007e).
   *
   * @generated from field: bool completed_is_assignee_not_applicable = 32;
   */
  completedIsAssigneeNotApplicable: boolean;

  /**
   * Mirrors internalapi.v1.SubStepInstance.approval_setting_mode: the mode of
   * the 承認フロー設定 copied onto this sub-step at case creation. Unset exactly
   * when the sub-step holds no copied setting (e.g. スポット / 時間前入札).
   *
   * @generated from field: optional bfftypes.v1.ApprovalMode approval_setting_mode = 33;
   */
  approvalSettingMode?: ApprovalMode;
};

/**
 * Describes the message bffuser.v1.SubStepInstance.
 * Use `create(SubStepInstanceSchema)` to create a new message.
 */
export const SubStepInstanceSchema: GenMessage<SubStepInstance> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_model, 3);

/**
 * SubStepUndoneCompletion is one 完了取消 recorded in the sub-step history
 * (spec AC-WFW-005f): the completion that was undone and the undo itself.
 *
 * @generated from message bffuser.v1.SubStepUndoneCompletion
 */
export type SubStepUndoneCompletion = Message<"bffuser.v1.SubStepUndoneCompletion"> & {
  /**
   * completed_by is the eauth member_id of the actor of the undone
   * completion. Unset for records backfilled from the legacy single-slot
   * columns, where the undone completion had already been cleared.
   *
   * @generated from field: optional string completed_by = 1;
   */
  completedBy?: string;

  /**
   * completed_at is the timestamp of the undone completion. Unset for
   * backfilled records (see completed_by).
   *
   * @generated from field: optional google.protobuf.Timestamp completed_at = 2;
   */
  completedAt?: Timestamp;

  /**
   * undone_by is the eauth member_id of the actor who undid the completion.
   *
   * @generated from field: string undone_by = 3;
   */
  undoneBy: string;

  /**
   * undone_at is the timestamp at which the completion was undone.
   *
   * @generated from field: google.protobuf.Timestamp undone_at = 4;
   */
  undoneAt?: Timestamp;

  /**
   * completed_is_assignee_not_applicable is 「担当者非該当」 of the undone
   * completion (spec AC-WFW-007e / AC-WFW-005f). False for backfilled records.
   *
   * @generated from field: bool completed_is_assignee_not_applicable = 5;
   */
  completedIsAssigneeNotApplicable: boolean;
};

/**
 * Describes the message bffuser.v1.SubStepUndoneCompletion.
 * Use `create(SubStepUndoneCompletionSchema)` to create a new message.
 */
export const SubStepUndoneCompletionSchema: GenMessage<SubStepUndoneCompletion> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_model, 4);

/**
 * SubStepStageApproval records a single approver's approval for a stage.
 * Mirrors internalapi.v1.SubStepStageApproval.
 *
 * @generated from message bffuser.v1.SubStepStageApproval
 */
export type SubStepStageApproval = Message<"bffuser.v1.SubStepStageApproval"> & {
  /**
   * @generated from field: string member_id = 1;
   */
  memberId: string;

  /**
   * @generated from field: google.protobuf.Timestamp approved_at = 2;
   */
  approvedAt?: Timestamp;

  /**
   * note is an optional free-text memo the approver entered at approval time
   * (spec AC-WFW-007d). Mirrors internalapi.v1.SubStepStageApproval.note.
   *
   * @generated from field: optional string note = 3;
   */
  note?: string;

  /**
   * is_approver_not_applicable is true when member_id was not a designated
   * approver of the stage at approval time (spec AC-WFW-007a). Mirrors
   * internalapi.v1.SubStepStageApproval.is_approver_not_applicable.
   *
   * @generated from field: bool is_approver_not_applicable = 4;
   */
  isApproverNotApplicable: boolean;

  /**
   * is_self_approval is true when member_id was the sub-step's applicant
   * (spec AC-WFW-007a). Mirrors
   * internalapi.v1.SubStepStageApproval.is_self_approval.
   *
   * @generated from field: bool is_self_approval = 5;
   */
  isSelfApproval: boolean;
};

/**
 * Describes the message bffuser.v1.SubStepStageApproval.
 * Use `create(SubStepStageApprovalSchema)` to create a new message.
 */
export const SubStepStageApprovalSchema: GenMessage<SubStepStageApproval> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_model, 5);

/**
 * SubStepApprovalStage is the backend-resolved approval view for one stage
 * of a sub-step's approval configuration. Mirrors
 * internalapi.v1.SubStepApprovalStage.
 *
 * @generated from message bffuser.v1.SubStepApprovalStage
 */
export type SubStepApprovalStage = Message<"bffuser.v1.SubStepApprovalStage"> & {
  /**
   * stage_order is 1-indexed.
   *
   * @generated from field: int32 stage_order = 1;
   */
  stageOrder: number;

  /**
   * strategy determines how approvals are counted (all / any).
   *
   * @generated from field: bfftypes.v1.ApprovalStrategy strategy = 2;
   */
  strategy: ApprovalStrategy;

  /**
   * approver_member_ids lists the member IDs designated as approvers for this
   * stage, resolved from the live approval configuration at response time.
   *
   * @generated from field: repeated string approver_member_ids = 3;
   */
  approverMemberIds: string[];

  /**
   * approved lists the approvals that have been recorded for this stage.
   *
   * @generated from field: repeated bffuser.v1.SubStepStageApproval approved = 4;
   */
  approved: SubStepStageApproval[];

  /**
   * previous_notes lists the preserved "前回承認時の申し送り" records for this
   * stage: notes of approvals that were cleared by a past 差戻し (cancel),
   * retained as an audit trail (spec AC-WFW-007c/d, workflow-fix-approval-ux
   * Design Note Decision #1/#2). Mirrors
   * internalapi.v1.SubStepApprovalStage.previous_notes.
   *
   * @generated from field: repeated bffuser.v1.SubStepStageApprovalNote previous_notes = 5;
   */
  previousNotes: SubStepStageApprovalNote[];

  /**
   * is_satisfied mirrors internalapi.v1.SubStepApprovalStage.is_satisfied.
   *
   * @generated from field: bool is_satisfied = 6;
   */
  isSatisfied: boolean;

  /**
   * is_unlocked mirrors internalapi.v1.SubStepApprovalStage.is_unlocked (the
   * order gate of spec AC-WFW-007a).
   *
   * @generated from field: bool is_unlocked = 7;
   */
  isUnlocked: boolean;

  /**
   * viewer_is_approver_not_applicable mirrors
   * internalapi.v1.SubStepApprovalStage.viewer_is_approver_not_applicable:
   * an approval of this stage by the viewer (the signed-in member) would be
   * recorded as 「承認者非該当」.
   *
   * @generated from field: bool viewer_is_approver_not_applicable = 8;
   */
  viewerIsApproverNotApplicable: boolean;

  /**
   * is_current mirrors internalapi.v1.SubStepApprovalStage.is_current: the
   * first unsatisfied stage, whose approvers a cancel (差戻し) is judged
   * against (spec AC-WFW-007c).
   *
   * @generated from field: bool is_current = 9;
   */
  isCurrent: boolean;
};

/**
 * Describes the message bffuser.v1.SubStepApprovalStage.
 * Use `create(SubStepApprovalStageSchema)` to create a new message.
 */
export const SubStepApprovalStageSchema: GenMessage<SubStepApprovalStage> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_model, 6);

/**
 * SubStepStageApprovalNote is a preserved "前回承認時の申し送り" record: the
 * note of an approval that was cleared by a 差戻し (cancel), retained as an
 * audit trail (Decision #1). Identity (for UpdatePreviousApprovalNote /
 * DeletePreviousApprovalNote) is the compound (parent stage's coordinate) +
 * member_id + cancelled_at. Mirrors internalapi.v1.SubStepStageApprovalNote.
 *
 * @generated from message bffuser.v1.SubStepStageApprovalNote
 */
export type SubStepStageApprovalNote = Message<"bffuser.v1.SubStepStageApprovalNote"> & {
  /**
   * @generated from field: string member_id = 1;
   */
  memberId: string;

  /**
   * @generated from field: google.protobuf.Timestamp approved_at = 2;
   */
  approvedAt?: Timestamp;

  /**
   * note is the preserved memo body (Design Note Contract/Data literal:
   * min_len=1). NOTE: UpdatePreviousApprovalNoteRequest.note can blank a
   * preserved note out to the empty string (backend domain entity
   * SubStepPreviousApprovalNote.note godoc) — protovalidate is enforced on
   * incoming requests only (not outgoing responses per this codebase's
   * interceptor wiring), so this response-side min_len is documentation of
   * the steady-state expectation, not a runtime guarantee once a note has
   * been blanked. Design Note assumption, recorded for the implementer.
   *
   * @generated from field: string note = 3;
   */
  note: string;

  /**
   * @generated from field: google.protobuf.Timestamp cancelled_at = 4;
   */
  cancelledAt?: Timestamp;

  /**
   * @generated from field: string cancelled_by = 5;
   */
  cancelledBy: string;
};

/**
 * Describes the message bffuser.v1.SubStepStageApprovalNote.
 * Use `create(SubStepStageApprovalNoteSchema)` to create a new message.
 */
export const SubStepStageApprovalNoteSchema: GenMessage<SubStepStageApprovalNote> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_model, 7);

/**
 * WorkflowCaseStatus is a derived (computed) field that reflects the overall
 * progress of a WorkflowCase. Mirrors internalapi.v1.WorkflowCaseStatus.
 *
 * DELETED is an irreversible logical delete (DeleteWorkflowCase RPC,
 * workflow-delete-transition design). Only a NOT_STARTED or IN_PROGRESS
 * case can be deleted; there is no way to reverse a delete.
 *
 * @generated from enum bffuser.v1.WorkflowCaseStatus
 */
export enum WorkflowCaseStatus {
  /**
   * @generated from enum value: WORKFLOW_CASE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_CASE_STATUS_NOT_STARTED = 1;
   */
  NOT_STARTED = 1,

  /**
   * @generated from enum value: WORKFLOW_CASE_STATUS_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: WORKFLOW_CASE_STATUS_COMPLETE = 3;
   */
  COMPLETE = 3,

  /**
   * @generated from enum value: WORKFLOW_CASE_STATUS_DELETED = 4;
   */
  DELETED = 4,

  /**
   * SUSPENDED mirrors internalapi.v1.WorkflowCaseStatus.SUSPENDED.
   *
   * @generated from enum value: WORKFLOW_CASE_STATUS_SUSPENDED = 5;
   */
  SUSPENDED = 5,
}

/**
 * Describes the enum bffuser.v1.WorkflowCaseStatus.
 */
export const WorkflowCaseStatusSchema: GenEnum<WorkflowCaseStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_case_model, 0);

/**
 * WorkflowCaseViewerAction is the derived "あなたの対応" of a WorkflowCase from
 * the point of view of the calling user. Mirrors
 * internalapi.v1.WorkflowCaseViewerAction 1:1 (same values, same numbers);
 * the viewer is resolved by the BFF from the eauth session, never sent by the
 * frontend (workflow-list-action-columns design). See the internalapi enum's
 * godoc for the 4-value priority order (workflow-case-list-12col-viewer-
 * action-4value slice).
 *
 * @generated from enum bffuser.v1.WorkflowCaseViewerAction
 */
export enum WorkflowCaseViewerAction {
  /**
   * @generated from enum value: WORKFLOW_CASE_VIEWER_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 要対応
   *
   * @generated from enum value: WORKFLOW_CASE_VIEWER_ACTION_REQUIRED = 1;
   */
  REQUIRED = 1,

  /**
   * 待ち
   *
   * @generated from enum value: WORKFLOW_CASE_VIEWER_ACTION_WAITING = 2;
   */
  WAITING = 2,

  /**
   * —
   *
   * @generated from enum value: WORKFLOW_CASE_VIEWER_ACTION_NONE = 3;
   */
  NONE = 3,

  /**
   * 要承認
   *
   * @generated from enum value: WORKFLOW_CASE_VIEWER_ACTION_APPROVAL_REQUIRED = 4;
   */
  APPROVAL_REQUIRED = 4,
}

/**
 * Describes the enum bffuser.v1.WorkflowCaseViewerAction.
 */
export const WorkflowCaseViewerActionSchema: GenEnum<WorkflowCaseViewerAction> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_case_model, 1);

/**
 * SubStepCompletionTrigger is what made the latest completion attempt of a
 * sub-step (spec AC-WFW-007f).
 *
 * @generated from enum bffuser.v1.SubStepCompletionTrigger
 */
export enum SubStepCompletionTrigger {
  /**
   * @generated from enum value: SUB_STEP_COMPLETION_TRIGGER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * MANUAL: the executor's 「完了にする」 on the workflow screen (手動完了).
   *
   * @generated from enum value: SUB_STEP_COMPLETION_TRIGGER_MANUAL = 1;
   */
  MANUAL = 1,

  /**
   * LINKED_OPERATION: the business operation of the linked page (需要想定の確定・
   * 計画の提出・対応済).
   *
   * @generated from enum value: SUB_STEP_COMPLETION_TRIGGER_LINKED_OPERATION = 2;
   */
  LINKED_OPERATION = 2,
}

/**
 * Describes the enum bffuser.v1.SubStepCompletionTrigger.
 */
export const SubStepCompletionTriggerSchema: GenEnum<SubStepCompletionTrigger> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_case_model, 2);

/**
 * SubStepStatus is a derived (computed) field that reflects the progress of
 * a single SubStepInstance. Mirrors internalapi.v1.SubStepStatus.
 *
 * @generated from enum bffuser.v1.SubStepStatus
 */
export enum SubStepStatus {
  /**
   * @generated from enum value: SUB_STEP_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUB_STEP_STATUS_NOT_STARTED = 1;
   */
  NOT_STARTED = 1,

  /**
   * @generated from enum value: SUB_STEP_STATUS_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: SUB_STEP_STATUS_AWAITING_APPROVAL = 3;
   */
  AWAITING_APPROVAL = 3,

  /**
   * @generated from enum value: SUB_STEP_STATUS_COMPLETE = 4;
   */
  COMPLETE = 4,

  /**
   * SUB_STEP_STATUS_APPROVAL_WITHDRAWN mirrors
   * internalapi.v1.SubStepStatus.SUB_STEP_STATUS_APPROVAL_WITHDRAWN.
   *
   * @generated from enum value: SUB_STEP_STATUS_APPROVAL_WITHDRAWN = 5;
   */
  APPROVAL_WITHDRAWN = 5,
}

/**
 * Describes the enum bffuser.v1.SubStepStatus.
 */
export const SubStepStatusSchema: GenEnum<SubStepStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_case_model, 3);

/**
 * WorkflowCaseErrorReason mirrors internalapi.v1.WorkflowCaseErrorReason 1:1
 * (same values, same numbers; pinned by go/internal/lint/filechecks/protocontract).
 *
 * @generated from enum bffuser.v1.WorkflowCaseErrorReason
 */
export enum WorkflowCaseErrorReason {
  /**
   * @generated from enum value: WORKFLOW_CASE_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_CASE_ERROR_REASON_APPROVER_ALL_INACTIVE = 1;
   */
  APPROVER_ALL_INACTIVE = 1,

  /**
   * WORKFLOW_CASE_ERROR_REASON_WORKFLOW_CASE_DELETED means the linked
   * workflow case was deleted; the plan must be re-requested from a new
   * workflow.
   *
   * @generated from enum value: WORKFLOW_CASE_ERROR_REASON_WORKFLOW_CASE_DELETED = 2;
   */
  WORKFLOW_CASE_DELETED = 2,

  /**
   * WORKFLOW_CASE_ERROR_REASON_TEMPLATE_REQUIRES_BG means CreateWorkflowCases
   * was called with no_bg_target against a template that requires no BG code
   * yet has an approval-target sub-step (発電販売計画 / 需要抑制計画), so a
   * bg_code is required for the approval gate (issue #5219 Decisions #13/#15).
   * 需要調達計画 / 入札 templates require a BG code themselves (#7209) and are
   * rejected as a plain axis mismatch before this check.
   *
   * @generated from enum value: WORKFLOW_CASE_ERROR_REASON_TEMPLATE_REQUIRES_BG = 3;
   */
  TEMPLATE_REQUIRES_BG = 3,

  /**
   * WORKFLOW_CASE_ERROR_REASON_MANUAL_COMPLETION_AWAITING_APPROVAL means the
   * plan cannot be submitted from the plan screen while the linked 計画提出
   * sub-step, completed by hand (AC-WFW-007f), is awaiting approval. Submit
   * after the approval or the 差戻し.
   *
   * @generated from enum value: WORKFLOW_CASE_ERROR_REASON_MANUAL_COMPLETION_AWAITING_APPROVAL = 4;
   */
  MANUAL_COMPLETION_AWAITING_APPROVAL = 4,

  /**
   * WORKFLOW_CASE_ERROR_REASON_SUSPENDED mirrors the internalapi value: the
   * mutation targets a suspended workflow case.
   *
   * @generated from enum value: WORKFLOW_CASE_ERROR_REASON_SUSPENDED = 5;
   */
  SUSPENDED = 5,
}

/**
 * Describes the enum bffuser.v1.WorkflowCaseErrorReason.
 */
export const WorkflowCaseErrorReasonSchema: GenEnum<WorkflowCaseErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_case_model, 4);

